import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchEventAccountsQueryVariables = Types.Exact<{
  query: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  filter?: Types.InputMaybe<Types.EventAccountSearchFilter>;
}>;


export type SearchEventAccountsQuery = { __typename?: 'Query', searchEventAccounts: Array<{ __typename?: 'EventAccountSearchResult', id: string, name?: string | null, company_name?: string | null, is_event_account: boolean, parent_account_id?: string | null, is_top_level: boolean, has_children: boolean, store_count: number }> };


export const SearchEventAccountsDocument = gql`
    query searchEventAccounts($query: String!, $limit: Int, $filter: EventAccountSearchFilter) {
  searchEventAccounts(query: $query, limit: $limit, filter: $filter) {
    id
    name
    company_name
    is_event_account
    parent_account_id
    is_top_level
    has_children
    store_count
  }
}
    `;

/**
 * __useSearchEventAccountsQuery__
 *
 * To run a query within a React component, call `useSearchEventAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEventAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEventAccountsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchEventAccountsQuery(baseOptions: Apollo.QueryHookOptions<SearchEventAccountsQuery, SearchEventAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEventAccountsQuery, SearchEventAccountsQueryVariables>(SearchEventAccountsDocument, options);
      }
export function useSearchEventAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEventAccountsQuery, SearchEventAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEventAccountsQuery, SearchEventAccountsQueryVariables>(SearchEventAccountsDocument, options);
        }
export type SearchEventAccountsQueryHookResult = ReturnType<typeof useSearchEventAccountsQuery>;
export type SearchEventAccountsLazyQueryHookResult = ReturnType<typeof useSearchEventAccountsLazyQuery>;
export type SearchEventAccountsQueryResult = Apollo.QueryResult<SearchEventAccountsQuery, SearchEventAccountsQueryVariables>;